"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "affectedCommand", {
    enumerable: true,
    get: function() {
        return affectedCommand;
    }
});
const _commander = require("commander");
const _action = require("./action.js");
const _addOptions = require("../addOptions.js");
const affectedCommand = new _commander.Command("affected");
(0, _addOptions.addOptions)("filter", affectedCommand).action(_action.affectedAction);
